import { render, staticRenderFns } from "./UserScenarioCard.vue?vue&type=template&id=0878738f&scoped=true&"
import script from "./UserScenarioCard.vue?vue&type=script&lang=js&"
export * from "./UserScenarioCard.vue?vue&type=script&lang=js&"
import style0 from "./UserScenarioCard.vue?vue&type=style&index=0&id=0878738f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878738f",
  null
  
)

export default component.exports